import React from 'react';

import { useButtonOptimisticState } from '../useButtonOptimisticState';
import { AddToBasketButtonUI } from '../AddToBasketButtonUI';

import { roundPrice } from '../roundPrice';

export function DishLayoutPrimary(props) {
    const {
        id,
        price,
        portion,
        dishCountStep,
        originalPrice,
        trackAddToBasket,
    } = props;

    const { isDishInBasket, handleAddToBasket } = useButtonOptimisticState(
        id,
        portion,
        dishCountStep,
        trackAddToBasket,
    );

    const priceWithPortions = roundPrice(price * dishCountStep);
    const originalPriceWithPortions = roundPrice(originalPrice * dishCountStep);

    const hasDiscount = price !== originalPrice;

    return (
        <AddToBasketButtonUI
            handleAddToBasket={handleAddToBasket}
            isDishInBasket={isDishInBasket}
            buttonsDisabled={false}
            hasDiscount={hasDiscount}
            price={priceWithPortions}
            originalPrice={originalPriceWithPortions}
        />
    );
}
